import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withStyles} from 'material-ui/styles';
import styles from './style/styles';
import WebinarEditForm from './forms/EditWebinarForm';
import {fetchSites} from '../sites/thunks';
import {fetchWebinar, updateWebinar} from './thunks';

class WebinarEdit extends Component {
    componentWillMount() {
        this.props.fetchWebinar(this.props.match.params.id);
        this.props.fetchSites();
    }

    handleEditWebinarSubmit(formProps) {
        this.props.updateWebinar(formProps);
    }

    render() {
        return (
            this.props.loading !== true && (
                <WebinarEditForm
                    statuses={this.props.statuses}
                    allSites={this.props.allSites}
                    initialValues={this.props.initialValues}
                    classes={this.props.classes}
                    handleFormSubmit={this.handleEditWebinarSubmit.bind(this)}
                    touched={this.props.touched}
                    loading={this.props.loading}
                />
            )
        );
    }
}

const mapStateToProps = state => {
    const webinarSites = [];

    if (state.webinars.webinar.sites) {
        state.webinars.webinar.sites.map((site) =>
            site.value
                ? webinarSites.push({
                      value: site.value,
                      label: site.label,
                  })
                : webinarSites.push({
                      value: site.id,
                      label: site.name,
                  })
        );
    }

    return {
        initialValues: {
            id: state.webinars.webinar.id,
            sites: webinarSites,
            event_title: state.webinars.webinar.event_title,
            event_short_description:
                state.webinars.webinar.event_short_description,
            event_id: state.webinars.webinar.event_id,
            start_date:
                state.webinars.webinar.start_date &&
                new Date(state.webinars.webinar.start_date),
            touched: state.webinars.touched,
        },
        statuses: state.webinars.statuses,
        loading: state.layout.ajaxCallsInProgress > 0,
        touched: state.webinars.touched,
        allSites: state.sites.all,
    };
}

export default connect(
    mapStateToProps,
    {
        fetchWebinar,
        updateWebinar,
        fetchSites,
    }
)(withStyles(styles)(WebinarEdit));



// WEBPACK FOOTER //
// ./src/containers/webinars/WebinarEdit.jsx